import { createSlice } from "@reduxjs/toolkit";
// import storage from "../../services/storage";

//const token = storage.get("classToken") || "";

const initialState = {
  studentReader: {
    topScroll: 0,
    chapter: 0,
    section: 0,
  },
};

const slice = createSlice({
  name: "studentReader",
  initialState,

  reducers: {
    setTopScroll: (state, action) => {
      state.studentReader.topScroll = action.payload;
    },
    setChapter: (state, action) => {
      state.studentReader.chapter = action.payload;
    },
    resetChapter: (state) => {
      state.studentReader.chapter = initialState.studentReader.chapter;
    },
    setSection: (state, action) => {
      state.studentReader.section = action.payload;
    },
    resetSection: (state) => {
      state.studentReader.section = initialState.studentReader.section;
    },
  },
});

export const { setTopScroll, setChapter, setSection } = slice.actions;
export default slice.reducer;
